import { render, staticRenderFns } from "./MainsConnection.vue?vue&type=template&id=794a8e7a&scoped=true&"
import script from "./MainsConnection.vue?vue&type=script&lang=ts&"
export * from "./MainsConnection.vue?vue&type=script&lang=ts&"
import style0 from "./MainsConnection.vue?vue&type=style&index=0&id=794a8e7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794a8e7a",
  null
  
)

export default component.exports